__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/beba92f/_next/";